// VariableProvider.js
import React, { useState, useEffect,useMemo  } from "react";
import VariableContext from "../contexts/VariableContext";
import config from "../configs/config";
import axios from "axios";

const VariableProvider = ({ children }) => {
  const [variables, setVariables] = useState([]);
  const [selectedVariables, setSelectedVariables] = useState([]);
  const [dataGroup, setdataGroup] = useState(null); // Assuming qgroup data is managed here
  const [sdataGroup, setSdataGroup] = useState(null);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState(null);
  // Crosstab specific
  const [crosstabSelectedVars, setCrosstabSelectedVars] = useState([]);
const [originalDataRows, setOriginalDataRows]= useState([]);
  // NEW: raw data loaded from backend (originalDataRows / fdata)
  // const [originalDataRows, setOriginalDataRows] = useState(() => {
  //   try {
  //     const saved = localStorage.getItem("originalDataRows");
  //     return saved ? JSON.parse(saved) : [];
  //   } catch {
  //     return [];
  //   }
  // });

  const [projectId, setProjectId] = useState(() => {
    // Initialize from localStorage on first load
    return localStorage.getItem("currentProjectId") || null;
  });
  const [banners, setBanners] = useState([]);
  // Unified weighting data: { [variable]: { [key]: { freq, target, weightedCount } } }
  const [weightingData, setWeightingData] = useState({});
  const [currentSelectedVariables, setCurrentSelectedVariables] = useState([]);
  const [selectedClient, setSelectedClient] = useState(() => {
    try {
      const saved = localStorage.getItem("selectedClient");
      return saved ? JSON.parse(saved) : {};
    } catch { return {}; }
  });
  const [selectedProject, setSelectedProject] = useState(() => {
    try {
      const saved = localStorage.getItem("selectedProject");
      return saved ? JSON.parse(saved) : {};
    } catch { return {}; }
  });
  const [loading, setLoading] = useState(false); // State for loading indicator
  const [powner, setPowner] = useState("");
  const [currentSelectedVariablesset, setcurrentSelectedVariablesset] =
    useState([]);
  const [weightingStats, setWeightingStats] = useState({});
  const [savedWeightings, setSavedWeightings] = useState({});

  // Registry for drag-and-drop handlers from different components
  const [dndHandlers, setDndHandlers] = useState({});

  const registerDndHandler = (name, handler) => {
    setDndHandlers((prev) => ({ ...prev, [name]: handler }));
  };

  const [surveyFileName, setSurveyFileName] = useState(() => {
    return localStorage.getItem("surveyFileName") || "";
  });

  const [surveyName, setSurveyName] = useState(() => {
    return localStorage.getItem("surveyName") || "";
  });
  const updateSdataGroup = (newSdataGroup) => {
    setSdataGroup(newSdataGroup);
  };
  useEffect(() => {
    if (dataGroup && Object.keys(dataGroup).length > 0) {
      localStorage.removeItem("dataGroup");
      localStorage.setItem("dataGroup", JSON.stringify(dataGroup));
    }
  }, [dataGroup]);

  useEffect(() => {
    const saved = localStorage.getItem("dataGroup");
    if (saved) {
      setdataGroup(JSON.parse(saved));
    }
  }, []);

  useEffect(() => {
    if (projectId) {
      setSdataGroup({}); // Clear previous survey data when project changes
      localStorage.setItem("currentProjectId", projectId);
    }
  }, [projectId]);

  useEffect(() => {
    if (surveyFileName) {
      localStorage.setItem("surveyFileName", surveyFileName);
    }
  }, [surveyFileName]);

  // Persist surveyName to localStorage
  useEffect(() => {
    if (surveyName) {
      localStorage.setItem("surveyName", surveyName);
    }
  }, [surveyName]);

  // Persist originalDataRows to localStorage so a reload still has the data
  // useEffect(() => {
  //   try {
  //     localStorage.setItem(
  //       "originalDataRows",
  //       JSON.stringify(originalDataRows || [])
  //     );
  //   } catch (e) {
  //     // ignore localStorage write errors
  //   }
  // }, [originalDataRows]);

  // useEffect(() => {
  //   const saved = localStorage.getItem("originalDataRows");
  //   if (saved) {
  //     setOriginalDataRows(JSON.parse(saved));
  //   }
  // }, []);

  // helper functions (some from your earlier provider)
  const setSurveyFileNameWithStorage = (fileName) => {
    setSurveyFileName(fileName);
    if (fileName) {
      localStorage.setItem("surveyFileName", fileName);
    } else {
      localStorage.removeItem("surveyFileName");
    }
  };

  const setSurveyNameWithStorage = (name) => {
    setSurveyName(name);
    if (name) {
      localStorage.setItem("surveyName", name);
    } else {
      localStorage.removeItem("surveyName");
    }
  };

  // Clear survey data when switching projects
  const setProjectIdWithClear = (newProjectId) => {
    setProjectId(newProjectId);
    // Clear survey data when switching projects
    if (newProjectId !== projectId) {
      setSurveyFileNameWithStorage("");
      setSurveyNameWithStorage("");
    }
  };

  const retrieveBannersFromBackend = async () => {
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/retrieve/${projectId}`
      );
      const data = await response.json();
      if (response.ok) {
        const bannerArray = JSON.parse(data.banner_json); // This line is added to parse the JSON string into an array
        setBanners(bannerArray); // Assuming you have a state setter `setBanners` defined
      } else {
        console.error("Failed to retrieve banners:", data);
      }
    } catch (error) {
      console.error("Error retrieving banners:", error);
    }
  };

  // Function to load a selected weighting
  const loadWeightingData = (selectedWeighting) => {
    if (!selectedWeighting) return;

    let data = selectedWeighting.data;

    // Backward-compat: migrate old format { targetPercentages, weightedCounts, frequencyData }
    if (!data && selectedWeighting.targetPercentages) {
      const tp = selectedWeighting.targetPercentages || {};
      const wc = selectedWeighting.weightedCounts || {};
      const fd = selectedWeighting.frequencyData || {};
      data = {};
      Object.entries(tp).forEach(([variable, keys]) => {
        data[variable] = {};
        Object.entries(keys).forEach(([key, target]) => {
          data[variable][key] = {
            freq: fd[variable]?.[key] ?? 0,
            target: target ?? '',
            weightedCount: wc[variable]?.[key] ?? null,
          };
        });
      });
    }

    const variables = Object.keys(data || {});
    setCurrentSelectedVariables(variables);
    setcurrentSelectedVariablesset(variables);
    setWeightingData({ ...(data || {}) });
    setWeightingStats({ ...selectedWeighting.stats });
  };

  const fetchWeights = async () => {
    try {
      const response = await axios.get(
        `${config.API_BASE_URL}/getweightings/${projectId}`
      );
      const weightingsData = response.data;

      // Assuming weightingsData is an object with a 'weighting_json' property containing the weightings.
      if (weightingsData.weighting_json) {
        const weightingsJson = weightingsData.weighting_json;
        setSavedWeightings(weightingsJson);
        const weightingNames = Object.keys(weightingsJson);
        if (weightingNames.length > 0) {
          loadWeightingData(weightingsJson[weightingNames[0]]);
        } else {
          // console.log ('No weightings available for this project.');
        }
      }
    } catch (error) {
      console.error("Failed to fetch weightings:", error);
    }
  };
  const fetchFrequencyDataForVariables = async (variables) => {
    try {
      const response = await axios.post(config.API_BASE_URL + "/wtfrequency", { variables });
      const raw = response.data; // { var: { key: { freq } } } (new backend format)
      setWeightingData(prev => {
        const updated = { ...prev };
        Object.entries(raw).forEach(([variable, keys]) => {
          if (!updated[variable]) updated[variable] = {};
          Object.entries(keys).forEach(([key, rowData]) => {
            const freqVal = typeof rowData === 'object' ? (rowData.freq ?? 0) : (rowData ?? 0);
            updated[variable][key] = {
              freq: freqVal,
              target: updated[variable]?.[key]?.target ?? '',
              weightedCount: updated[variable]?.[key]?.weightedCount ?? null,
            };
          });
        });
        return updated;
      });
    } catch (error) {
      console.error("Error fetching frequency data:", error);
    }
  };
  const saveCurrentWeighting = (weightingName, stats, data) => {
    if (weightingName) {
      setSavedWeightings(prev => ({
        ...prev,
        [weightingName]: { data, stats },
      }));
    }
  };
const contextValue = useMemo(() => ({
  banners,
  setBanners,
  variables,
  setVariables,
  selectedVariables,
  setSelectedVariables,
  dataGroup,
  setdataGroup,
  projectId,
  setProjectId,
  retrieveBannersFromBackend,
  fetchWeights,
  savedWeightings,
  weightingData,
  setWeightingData,
  currentSelectedVariables,
  weightingStats,
  setCurrentSelectedVariables,
  setWeightingStats,
  saveCurrentWeighting,
  setSavedWeightings,
  currentSelectedVariablesset,
  setcurrentSelectedVariablesset,
  selectedClient,
  setSelectedClient,
  selectedProject,
  setSelectedProject,
  loading,
  setLoading,
  sdataGroup,
  setSdataGroup,
  surveyFileName,
  surveyName,
  powner,
  setPowner,
  setSurveyFileName: setSurveyFileNameWithStorage,
  setSurveyName: setSurveyNameWithStorage,
  updateSdataGroup,
  originalDataRows,
  setOriginalDataRows,
  crosstabSelectedVars,
  setCrosstabSelectedVars,
  selectedProjectDetails,
  setSelectedProjectDetails,
  dndHandlers,
  registerDndHandler,
}), [
  banners,
  variables,
  selectedVariables,
  dataGroup,
  projectId,
  savedWeightings,
  weightingData,
  currentSelectedVariables,
  weightingStats,
  currentSelectedVariablesset,
  selectedClient,
  selectedProject,
  loading,
  sdataGroup,
  surveyFileName,
  surveyName,
  powner,
  originalDataRows,
  crosstabSelectedVars,
  selectedProjectDetails,
  dndHandlers
]);

  return (
    <VariableContext.Provider value={contextValue}>
  {children}
</VariableContext.Provider>
  );
};

export default VariableProvider;
